<template>
  <div class="gift-page">
    <header>
      <button @click="$router.go(-1)">‹</button>
      <span>NEW MEMBER BENEFITS</span>
      <h1>新客专项礼</h1>
      <p>完成新客任务，逐步解锁专属礼遇与产品权益。</p>
    </header>

    <main>
      <section class="gift-card">
        <div class="gift-icon">礼</div>
        <div>
          <small>新客专享</small>
          <h2>注册认证礼遇</h2>
          <p>完成注册并通过实名认证后，系统自动赠送 8.88 USD 新客奖励。</p>
        </div>
      </section>

      <section class="registration-gift">
        <div class="registration-title">
          <span>REGISTRATION GIFT</span>
          <h2>新客注册礼物说明</h2>
          <p>{{ gift.newcomer_gift_intro }}</p>
        </div>
        <div class="gift-details">
          <article>
            <strong>领取条件</strong>
            <p>{{ gift.newcomer_gift_condition }}</p>
          </article>
          <article>
            <strong>礼物内容</strong>
            <p>{{ gift.newcomer_gift_content }}</p>
          </article>
          <article>
            <strong>发放方式</strong>
            <p>{{ gift.newcomer_gift_delivery }}</p>
          </article>
          <article>
            <strong>领取限制</strong>
            <p>{{ gift.newcomer_gift_limit }}</p>
          </article>
        </div>
      </section>

      <section class="rules">
        <h2>礼遇说明</h2>
        <article v-for="(item, index) in rules" :key="item.title">
          <span>0{{ index + 1 }}</span>
          <div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </article>
      </section>

      <section class="protection">
        <strong>权益保障</strong>
        <p>购买产品后，系统将根据订单生成本金及约定收益保障电子合同，并关联本人电子签名。可在“我的产品”中随时查看合同、保障权益和期限。</p>
      </section>

      <button class="primary" @click="$router.push('/register')">立即注册领取</button>
      <p class="activity-note">具体奖励内容、发放条件与有效期以活动页面和到账记录为准。</p>
    </main>
  </div>
</template>

<script>
import request from "@utils/request";

export default {
  name: "NewcomerGift",
  data() {
    return {
      gift: {
        newcomer_gift_intro: "新用户完成注册并通过实名认证后，可领取一次新客专享奖励。",
        newcomer_gift_condition: "完成新账号注册并通过实名认证。",
        newcomer_gift_content: "实名认证审核通过后，系统自动赠送 8.88 USD。",
        newcomer_gift_delivery: "奖励自动发放至可购买金额。",
        newcomer_gift_limit: "每位实名认证用户仅限领取一次，不可重复注册领取。"
      },
      rules: [
        { title: "完成账户注册", desc: "使用本人手机号注册并设置账户安全信息。" },
        { title: "完成实名认证", desc: "提交真实身份资料并等待审核通过，无需在实名认证时签名。" },
        { title: "领取 8.88 USD", desc: "认证通过后，奖励自动发放至可购买金额。" },
        { title: "购买时签署合同", desc: "购买产品时完成电子签名，并生成对应的电子合同。" }
      ]
    };
  },
  mounted() {
    request.get("/api/newcomer-gift", {}, { login: false }).then(res => {
      const data = (res && res.data && res.data.data) || {};
      this.gift = Object.assign({}, this.gift, data);
    }).catch(() => {});
  }
};
</script>

<style scoped>
.gift-page { min-height: 100vh; color: #17243b; background: #f4f7fb; }
.gift-page * { box-sizing: border-box; }
header {
  position: relative;
  padding: 22px 20px 55px;
  overflow: hidden;
  color: #fff;
  background:
    linear-gradient(90deg,rgba(4,25,57,.98) 0%,rgba(6,43,82,.86) 56%,rgba(8,68,111,.45) 100%),
    url("../../assets/images/asm-premium/chiplet-wafer.webp") 68% center / cover no-repeat;
  border-radius: 0 0 32px 32px;
  box-shadow: 0 16px 38px rgba(5,35,70,.16);
}
header::after { position: absolute; right: 19px; bottom: 22px; width: 180px; height: 31px; content: ""; opacity: .21; background: url("../../assets/images/asmpt_logo.svg") right center / contain no-repeat; filter: brightness(0) invert(1); pointer-events: none; }
header > * { position: relative; z-index: 1; }
header button { position: absolute; top: 14px; left: 16px; color: #fff; font-size: 32px; border: 0; background: none; }
header span { display: block; margin: 36px 0 9px; color: #9ed3ff; font-size: 10px; letter-spacing: 1.5px; }
header h1 { margin: 0 0 9px; font-size: 30px; }
header p { margin: 0; color: rgba(255,255,255,.78); font-size: 13px; }
main { padding: 14px 15px 30px; }
.gift-card { display: grid; grid-template-columns: 68px 1fr; gap: 14px; align-items: center; margin-top: 0; padding: 18px; background: #fff; border-radius: 20px; box-shadow: 0 12px 30px rgba(21,58,102,.12); }
.gift-icon { display: grid; width: 64px; height: 64px; place-items: center; color: #9b6420; font-size: 23px; font-weight: 700; background: linear-gradient(145deg,#fff0be,#ffd474); border-radius: 18px; }
.gift-card small { color: #b47d32; }
.gift-card h2 { margin: 4px 0 6px; font-size: 19px; }
.gift-card p,.rules p,.protection p,.activity-note { margin: 0; color: #718096; font-size: 12px; line-height: 1.7; }
.registration-gift {
  position: relative;
  margin-top: 14px;
  padding: 18px;
  overflow: hidden;
  background:
    linear-gradient(110deg,rgba(255,250,240,.985) 0%,rgba(255,255,255,.95) 70%,rgba(245,250,255,.9) 100%),
    url("../../assets/images/asm-premium/advanced-packaging-fab.webp") right top / auto 100% no-repeat;
  border: 1px solid #e6e4dc;
  border-radius: 20px;
  box-shadow: 0 10px 28px rgba(43,74,110,.07);
}
.registration-gift::after { position: absolute; right: -22px; top: -20px; width: 130px; height: 130px; content: ""; border: 1px solid rgba(34,105,164,.08); border-radius: 50%; box-shadow: 0 0 0 18px rgba(34,105,164,.025),0 0 0 38px rgba(34,105,164,.018); pointer-events: none; }
.registration-gift > * { position: relative; z-index: 1; }
.registration-title > span { color: #b98431; font-size: 9px; font-weight: 700; letter-spacing: 1.4px; }
.registration-title h2 { margin: 5px 0 6px; font-size: 18px; }
.registration-title p { margin: 0; color: #7d8796; font-size: 11px; line-height: 1.65; }
.gift-details { display: grid; grid-template-columns: 1fr 1fr; gap: 9px; margin-top: 14px; }
.gift-details article { padding: 12px; background: rgba(255,255,255,.9); border: 1px solid #f2ead9; border-radius: 13px; }
.gift-details strong { display: block; margin-bottom: 5px; color: #8f6426; font-size: 12px; }
.gift-details p { margin: 0; color: #758090; font-size: 10px; line-height: 1.6; }
.rules { margin-top: 14px; padding: 18px; background: #fff; border-radius: 20px; }
.rules > h2 { margin: 0 0 14px; font-size: 18px; }
.rules article { display: grid; grid-template-columns: 34px 1fr; gap: 10px; padding: 12px 0; border-top: 1px solid #eef1f5; }
.rules article:first-of-type { border-top: 0; }
.rules article > span { display: grid; width: 30px; height: 30px; place-items: center; color: #23659d; font-size: 11px; font-weight: 700; background: #e8f3fc; border-radius: 10px; }
.rules h3 { margin: 0 0 4px; font-size: 14px; }
.protection { margin-top: 14px; padding: 17px; color: #245b50; background: #eaf8f3; border-radius: 18px; }
.protection strong { display: block; margin-bottom: 6px; }
.protection p { color: #577a72; }
.primary { width: 100%; height: 48px; margin-top: 18px; color: #fff; font-size: 15px; font-weight: 700; border: 0; background: linear-gradient(90deg,#174b84,#2878ae); border-radius: 24px; }
.activity-note { padding: 12px 8px 0; text-align: center; font-size: 10px; }
</style>
